// extracted by mini-css-extract-plugin
export default {"home-page":"HomePage_home-page__6S7dT"};